<template>
    <div class="all-users-page">
        <section class="page-hero">
            <div class="hero-copy">
                <p class="eyebrow">Directory</p>
                <h1 class="page-title">Models</h1>
                <p class="page-subtitle">
                    Review model profiles, account types, and verification status from a cleaner admin workspace.
                </p>
            </div>

            <div class="hero-stats">
                <div class="stat-card">
                    <span class="stat-label">Total models</span>
                    <strong class="stat-value">{{ modelCount }}</strong>
                </div>
                <div class="stat-card">
                    <span class="stat-label">Verified</span>
                    <strong class="stat-value">{{ verifiedCount }}</strong>
                </div>
            </div>
        </section>

        <section class="page-card">
            <div class="contract-header">
                <div class="header-title">
                    <span class="count-badge">{{ modelCount }}</span>
                    <span>Models</span>
                </div>
                <div class="search-wrap">
                    <i class="fa fa-search" aria-hidden="true"></i>
                    <input v-model.trim="search" type="text" placeholder="Search models..." />
                </div>
            </div>

            <div class="table-shell">
                <v-data-table :headers="header" :items="filteredDesserts" dense class="models-table">
                    <template v-slot:item.fullname="{ item }">
                        <div class="cell-main">
                            <span class="cell-name">{{ item.fullname }}</span>
                            <span class="cell-sub">{{ item.username }}</span>
                        </div>
                    </template>
                    <template v-slot:item.email="{ item }">
                        <span class="cell-sub">{{ item.email }}</span>
                    </template>
                    <template v-slot:item.phone="{ item }">
                        <span class="cell-sub">{{ item.phone }}</span>
                    </template>
                    <template v-slot:item.gender="{ item }">
                        <span class="chip chip--neutral">{{ item.gender || '--' }}</span>
                    </template>
                    <template v-slot:item.activation="{ item }">
                        <span :class="['chip', item.activation == 1 ? 'chip--success' : 'chip--warning']">
                            {{ item.activation == 1 ? 'Verified' : 'Unverified' }}
                        </span>
                    </template>
                    <template v-slot:item.model_status="{ item }">
                        <span class="chip chip--info">{{ item.model_status || '--' }}</span>
                    </template>
                    <template v-slot:item.createdon="{ item }">
                        <span class="cell-sub">{{ formatDate(item.createdon) }}</span>
                    </template>
                    <template v-slot:item.action="{ item }">
                        <button class="action-btn" type="button" @click="openApprovalModal(item)">
                            View more <i class="fa fa-arrow-right"></i>
                        </button>
                    </template>
                </v-data-table>
            </div>
        </section>

        <div v-if="showApprovalModal" class="modal-backdrop-custom">
        <div class="modal-wrapper">
            <div class="modal-subs modal-lg shadow-lg rounded-3 overflow-hidden bg-white">
            <!-- Header -->
            <div class="modal-header subs-content text-white">
                <h5 class="modal-title">
                <i class="bi bi-person-check"></i> Approve Model
                </h5>
                <button
                type="button"
                class="btn-close btn-close-white"
                @click="closeApprovalModal"
                ></button>
            </div>

            <!-- Body -->
            <div class="modal-body p-4">
                <div class="verification-images mb-4">
                    <div class="image-card">
                        <span class="image-label">Profile photo</span>
                        <img
                            :src="selectedUser.picture || 'https://via.placeholder.com/120'"
                            alt="User Picture"
                            class="rounded-circle border shadow-sm"
                            width="120"
                            height="120"
                        />
                    </div>
                    <div class="image-card">
                        <span class="image-label">Verification photo</span>
                        <img
                            :src="selectedUser.verification_pic || 'https://via.placeholder.com/120?text=No+Image'"
                            alt="Verification Picture"
                            class="rounded-circle border shadow-sm"
                            width="120"
                            height="120"
                        />
                    </div>
                </div>

                <!-- User Details (2 columns) -->
                <div class="user-info px-3">
                <div class="row">
                    <div class="col-md-6 mb-3">
                    <strong class="text-muted">Username:</strong>
                    <div>{{ selectedUser.username }}</div>
                    </div>
                    <div class="col-md-6 mb-3">
                    <strong class="text-muted">Email:</strong>
                    <div>{{ selectedUser.email }}</div>
                    </div>
                    <div class="col-md-6 mb-3">
                    <strong class="text-muted">Phone:</strong>
                    <div>{{ selectedUser.phone }}</div>
                    </div>
                    <div class="col-md-6 mb-3" v-if="selectedUser.age">
                    <strong class="text-muted">Age:</strong>
                    <div>{{ selectedUser.age }}</div>
                    </div>
                    <div class="col-md-6 mb-3">
                    <strong class="text-muted">Location:</strong>
                    <div>{{ selectedUser.location }} {{ selectedUser.state }}</div>
                    </div>
                   
                    <div class="col-md-6 mb-3" v-if="selectedUser.country">
                    <strong class="text-muted">Country:</strong>
                    <div>{{ selectedUser.country }}</div>
                    </div>
                </div>
                </div>
            </div>

            <!-- Footer -->
            <div class="modal-footer d-flex justify-content-end bg-light px-4">
                <button
                type="button"
                class="btn btn-outline-secondary px-4 me-2"
                @click="closeApprovalModal"
                >
                Cancel
                </button>
                <button type="button" class="btn btn-success px-4" @click="approveUser(selectedUser.id)">
                 Block
                </button>
            </div>
            </div>
        </div>
        </div>
       
        <p>&nbsp;</p>
        <page-loader :is-loading="isLoading"></page-loader>
    </div>
</template>
     
<script>
//import swal from 'sweetalert2';
import PageLoader from '../components/PageLoader.vue'

export default {

    name: "AllUsersPage",
    components: {
        //quillEditor,
        PageLoader,
    },

    data() {
        return {

            isLoading: false,
            isRightImage: false,
            isLeftImage: false,
            isBackImage: false,
            is_transaction_fee: true,
            is_transaction_fee_hidden: false,
            user_id: '',
            firstname: '',
            lastname: '',
            bank_name: '',
            account_name: '',
            account_number: '',

            loading: false,
            loading1: false,
            loading2: false,
            loading3: false,
            role_type: '',
            contract_title: '',
            transaction_type: '',
            delivery_type: '',
            delivery_location: '',
            delivery_time: '',
            contract_amount: '',
            transaction_fee: '',
            whois_paying: '',
            contract_rebate: '',
            product_description: '',
            accept_terms: '',

            products: [],
            subcategorys: [],
            selectedFile: '',
            selectedFile1: '',
            selectedFile2: '',
            selectedFile3: '',
            addProduct: false,
            viewProduct: true,
            editorOptions: {
                placeholder: 'Write something...',
            },

            isVariations: false,
            productid: '',
            variations: '',
            vprice: '',
            is_fees_status: false,
            is_submit: false,
            is_submit1: false,
            is_submit2: false,
            is_submit3: false,
            img_url: process.env.VUE_APP_IMAGE_URL,
            header: [
                
                {
                    value: 'fullname',
                    text: 'Fullname'
                },
                {
                    value: 'username',
                    text: 'Username'
                },
                {
                    value: 'email',
                    text: 'Email'
                },             
                {
                    value: 'phone',
                    text: 'Phone'
                },
                {
                    value: 'gender',
                    text: 'Gender'
                },
                {
                    value: 'activation',
                    text: 'Status'
                },
                {
                    value: 'model_status',
                    text: 'Account type'
                },
                {
                    value: 'createdon',
                    text: 'Date registered'
                },
                {
                    value: 'action',
                    text: 'Action'
                },
                
            ],

            desserts: [],
            user_role: '',
            product_id: '',
            userid: '',
            modelData: [],
            isPeriod: false,
            delivery_period: '',
            payment_status: '',
            is_escrow_charge: false,
            error: '',
            error1: '',
            duration_twelve: false,
            duration_twelve1: true,
            label1: '',
            isContractLink: false,
            contractLink: '',
            service_charge_fee: '',
            search: '',

            showApprovalModal: false,
            selectedUser: {
                picture: "",
                verification_pic: "",
                username: "",
                email: "",
                phone: "",
                age: "",
                country: "",
                location: "",
                state: "",
                id: ""
            },
        };
    },

    beforeMount() {

    },

    mounted() {

        this.firstname = localStorage.getItem("firstname");
        this.lastname = localStorage.getItem("lastname");
        this.phone_number = localStorage.getItem("phone");
        this.email_address = localStorage.getItem("email");
        this.user_id = localStorage.getItem("userid");

        this.bank_name = localStorage.getItem("bank_name");
        this.account_name = localStorage.getItem("account_name");
        this.account_number = localStorage.getItem("account_number");
        this.user_role = localStorage.getItem("user_role");

        this.fetchAllModels()
    },

    created() {

    },

    computed: {
        modelCount() {
            return this.desserts.length
        },
        verifiedCount() {
            return this.desserts.filter((item) => Number(item.activation) === 1).length
        },
        filteredDesserts() {
            const term = String(this.search || '').trim().toLowerCase()
            if (!term) return this.desserts

            return this.desserts.filter((item) => {
                return ['fullname', 'username', 'email', 'phone', 'gender', 'model_status', 'createdon']
                    .some((field) => String(item[field] || '').toLowerCase().includes(term))
            })
        },

        indexSn() {
            return this.desserts.map((d, index) => ({
                ...d,
                sn: index + 1
            }))
        },

    },

    methods: {
        formatDate(value) {
            if (!value) return '--'
            const date = new Date(value)
            if (Number.isNaN(date.getTime())) return '--'
            return new Intl.DateTimeFormat('en-NG', {
                day: '2-digit',
                month: 'short',
                year: 'numeric',
            }).format(date)
        },
        validateNumber() {
        const value = this.delivery_period;
        if (value < 0) {
            this.error = 'Value must be non-negative';
            this.delivery_period = ''
            return
        } else if (!Number.isInteger(Number(value))) {
            this.error = 'Value must be an integer';
            this.delivery_period = ''
            return
        } else {
            this.error = '';
        }
        },

        formatToCurrency(value) {
            const amount = Number(value || 0)
            if (Number.isNaN(amount)) return '--'
            return amount.toLocaleString('en-NG', { minimumFractionDigits: 2 })
        },

        
        copied(){
            this.isContractLink = false
        },

        copyToClipboard(link) {
            // var copyText = document.getElementById("myInput");
            navigator.clipboard.writeText(link).then(function() {
                alert("Contract link copied to clipboard!");
            }).catch(function(err) {
                console.error('Failed to copy: ', err);
            });
        },

        copyToClipboard1(link) {
            // var copyText = document.getElementById("myInput");
            navigator.clipboard.writeText(link).then(function() {
                alert("Contract link copied to clipboard!");
            }).catch(function(err) {
                console.error('Failed to copy: ', err);
            });
        },
        async fetchAllModels() {
            try {
                this.isLoading = true
                this.desserts = []
                const response = await this.$http.get('/list-models', {
                    //user_id: this.user_id
                })
                this.isLoading = false
                
                //let photo_url = '';
                this.modelData = response.data.data
                this.modelData.forEach(el => {
                    this.desserts.push({
                        fullname: el.name,
                        username: el.username,
                        email: el.email_address,
                        phone: el.phone_number,
                        gender: el.gender,
                        activation: el.activation_paid,
                        model_status: el.account_type,
                        createdon: el.created_at,
                        action: el.hid,
                        photo_url: el.profilepic,
                        verification_pic: el.verification_pic,
                        age: el.age,
                        country: el.country,
                        location: el.location,
                        state: el.state,
                        
                    })
                });

            } catch (err) {
                console.log(err);
            }
        },

        openApprovalModal(user) {

        this.showApprovalModal = true;
        this.selectedUser = {
            picture: user.photo_url || "",
            verification_pic: user.verification_pic || "",
            username: user.username || "",
            email: user.email || "",
            phone: user.phone || "",
            age: user.age || "",
            country: user.country || "",
            location: user.location || "",
            state: user.state || "",
            id: user.action || ""
        };
        
        },
        closeApprovalModal() {
        this.showApprovalModal = false;
        },
        async approveUser(dataId) {
        try {
            // Prompt user for confirmation before proceeding
            if (!confirm("Are you sure you want to verify this user?")) {
                return; // stop if cancelled
            }

            const response = await this.$http.get(`/approve-escort/${dataId}`);

            if (response.data.status) {
                alert(response.data.message);
                this.closeApprovalModal();
                this.fetchAllModels();
            }
        } catch (err) {
            this.closeApprovalModal();
            alert(err.response ? err.response.data.message : err.message);
        }
    }

    }

}
</script>
      
<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;700&display=swap');

.all-users-page {
    min-height: 100vh;
    padding: 24px;
    background:
        radial-gradient(circle at top left, rgba(211, 62, 116, 0.12), transparent 30%),
        radial-gradient(circle at top right, rgba(8, 41, 74, 0.10), transparent 26%),
        linear-gradient(180deg, #f8fafc 0%, #eef3f8 100%);
    font-family: Poppins;
}

.page-hero {
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    gap: 20px;
    margin-bottom: 20px;
}

.hero-copy,
.stat-card,
.page-card {
    border: 1px solid rgba(15, 23, 42, 0.08);
    background: rgba(255, 255, 255, 0.92);
    box-shadow: 0 18px 45px rgba(15, 23, 42, 0.08);
    backdrop-filter: blur(16px);
}

.hero-copy {
    flex: 1;
    padding: 28px;
    border-radius: 24px;
}

.eyebrow {
    margin: 0;
    color: #d33e74;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.12em;
    text-transform: uppercase;
}

.page-title {
    margin: 8px 0 0;
    font-size: 32px;
    line-height: 1.1;
    font-weight: 700;
    color: #081b2d;
}

.page-subtitle {
    max-width: 720px;
    margin: 10px 0 0;
    color: #566375;
    font-size: 14px;
    line-height: 1.7;
}

.hero-stats {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;
    min-width: 320px;
}

.stat-card {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 8px;
    padding: 18px;
    border-radius: 18px;
}

.stat-label {
    font-size: 12px;
    font-weight: 600;
    color: #64748b;
    text-transform: uppercase;
    letter-spacing: 0.08em;
}

.stat-value {
    font-size: 28px;
    line-height: 1;
    color: #081b2d;
}

.page-card {
    padding: 22px;
    border-radius: 24px;
}

.header-title {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 18px;
    font-weight: 700;
    color: #081b2d;
}

.count-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 42px;
    padding: 8px 10px;
    border-radius: 999px;
    background: rgba(211, 62, 116, 0.12);
    color: #d33e74;
}

.search-wrap {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    max-width: 320px;
    height: 46px;
    padding: 0 14px;
    border-radius: 14px;
    border: 1px solid #d7dee8;
    background: #fff;
    color: #94a3b8;
}

.search-wrap input {
    width: 100%;
    border: 0;
    outline: 0;
    background: transparent;
    font-size: 14px;
    color: #081b2d;
}

.search-wrap input::placeholder {
    color: #94a3b8;
}

.table-shell {
    overflow: hidden;
    border-radius: 18px;
    border: 1px solid #e8edf3;
}

.models-table {
    font-family: Poppins;
}

.models-table ::v-deep .v-data-table__wrapper {
    overflow-x: auto;
}

.models-table ::v-deep table {
    min-width: 960px;
}

.models-table ::v-deep thead th {
    background: #f8fafc;
    color: #334155;
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    white-space: nowrap;
}

.models-table ::v-deep tbody td {
    font-size: 13px;
    color: #0f172a;
    vertical-align: middle;
}

.models-table ::v-deep tbody tr:hover {
    background: #f9fbff;
}

.cell-main {
    display: flex;
    flex-direction: column;
    gap: 3px;
}

.cell-name {
    font-size: 14px;
    font-weight: 700;
    color: #081b2d;
}

.cell-sub {
    font-size: 13px;
    color: #64748b;
    white-space: nowrap;
}

.chip {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 7px 12px;
    border-radius: 999px;
    font-size: 12px;
    font-weight: 700;
    white-space: nowrap;
    text-transform: capitalize;
}

.chip--success {
    background: rgba(34, 197, 94, 0.12);
    color: #15803d;
}

.chip--warning {
    background: rgba(245, 158, 11, 0.12);
    color: #b45309;
}

.chip--info {
    background: rgba(59, 130, 246, 0.12);
    color: #1d4ed8;
}

.chip--neutral {
    background: rgba(100, 116, 139, 0.12);
    color: #475569;
}

.action-btn {
    border: 0;
    padding: 10px 14px;
    border-radius: 999px;
    background: rgba(211, 62, 116, 0.08);
    color: #d33e74;
    font-size: 13px;
    font-weight: 700;
    cursor: pointer;
    transition: transform 0.2s ease, background 0.2s ease;
}

.action-btn:hover {
    transform: translateY(-1px);
    background: rgba(211, 62, 116, 0.14);
}

.verification-images {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 16px;
    justify-items: center;
}

.image-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    padding: 16px;
    width: 100%;
    border-radius: 18px;
    background: #f8fafc;
    border: 1px solid #e8edf3;
}

.image-label {
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    color: #64748b;
}
    /* Dark backdrop */
/* Backdrop */
    .modal-backdrop-custom {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.65);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1050;
    }

    /* Modal wrapper (center container) */
    .modal-wrapper {
    width: 100%;
    max-width: 600px;
    }

    /* Header */
    .subs-content {
    padding: 0.5rem;
    background-color: #D33E74; /* Bootstrap success green */
    }
    .btn-success{
        background-color: #D33E74; 
        border: 0px;
    }
    .btn-xs{
        padding: 0.2rem;
        border: 0px;
        font-family: Poppins;
        font-size: 12px;
        font-weight: 500;
    }
    .modal-footer{
        padding: 0.5rem;
    }
    /* User info */
    .user-info p {
    font-size: 1rem;
    color: #222;
    border-bottom: 1px solid #f1f1f1;
    padding-bottom: 8px;
    }
    .user-info p:last-child {
    border-bottom: none;
    }

    .user-info strong {
  display: block;
  font-size: 0.9rem;
  margin-bottom: 4px;
  color: #6c757d;
}
.user-info div {
  font-size: 1rem;
  color: #212529;
  font-weight: 500;
}

    .error {
        color: #fff;
      }
      .error1 {
        color: #fff;
      }
    .quill-container {
        height: 200px;
        /* Set the desired height here */
    }
    .copy-refid{
        cursor: pointer;
        font-size: 16px;
    }
    .copy-refid1{
        cursor: pointer;
        font-size: 15px;
        font-weight: 600;
    }
    .a-text {
        font-size: 12px;
        font-family: Poppins;
    }
    .a-text1 {
        font-size: 14px;
        font-family: Poppins;
    }
    .process-payment{
        cursor:pointer;
    
    }
    label {
        font-size: 12px;
        font-family: Poppins;
        font-weight: normal;
    }
    
    .inputs {
        margin-top: 20px;
        border-radius: 3px;
        font-size: 12px;
    }
    
    .price-fee {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    
        div {
            margin: 4px;
            width: 100%;
    
        }
    }
    
    .adjust-fee-input {
        // width: 100px;
        text-align: center;
    }
    
    .whopays-fee-input {
        //width: 100% !important;
    }
    
    .shop-detail {
        font-size: 12px;
        font-family: Poppins;
    }
    
    .btn-danger {
        text-transform: uppercase;
        font-size: 13px;
        font-family: Poppins;
        background: #D33E74;
        border: 0px;
        height: 45px;
    }
    
    .text-header {
        display: none;
    }
    
    .contract-header {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        gap: 16px;
        padding: 0 0 18px;
        margin-bottom: 18px;
        border-bottom: 1px solid #e8edf3;
        background: transparent;
        color: #081b2d;
        border-radius: 0;
        font-size: 14px;
        font-weight: 700;
        font-family: Poppins;
    }
    
    .welcome {
        display: none;
    }
    
    .account-details {
        display: block;
        border-radius: 0;
        background: transparent;
        width: 100%;
    }
    
    .account-balance {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        background: #780712;
        color: #fff;
        width: 100%;
        height: 100%;
        border-radius: 10px;
        font-family: Poppins;
        padding: 0.4rem;
        padding-left: 2rem;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    }
    
    .wallet-detail {
        padding-top: 1rem;
        line-height: 1.4px;
        font-size: 15px;
    
        h4 {
            font-weight: 650;
        }
    
        .acct-d {
            line-height: 0.8;
            cursor: pointer;
            text-decoration: underline;
        }
    }
    
    .wallet-icon {
        font-size: 60px
    }
    
    .fund-account {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        background: #076378;
        color: #fff;
        width: 100%;
        height: 100%;
        border-radius: 10px;
        font-family: Poppins;
        padding: 0.4rem;
        padding-left: 2rem;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    }
    
    .inputs-field {
        font-size: 14px;
        font-family: Poppins;
        height: 45px;
    }
    
    .content-center {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        border: solid 1px #170e0fac;
        border-radius: 4px;
        padding: 0.5rem;
        margin: 4px;
    }
    
    .box1 {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        border-radius: 10px;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
        font-family: Poppins;
    
        a {
            text-decoration: none;
            color: #000;
        }
    }
    
    .image-input {
        margin-top: 10px;
    }
    
    .box-icon {
        padding-left: 0.4rem;
        font-size: 35px;
        color: #637807;
    }
    
    .box-details {
        font-size: 14px;
        color: #170e0fac;
    }
    
    .box1:hover {
        transform: scale(1.1);
        transition: transform 0.3s ease;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.3), 0 6px 20px 0 rgba(0, 0, 0, 0.24);
        cursor: pointer;
    }
    
    .box2 {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        border-radius: 10px;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
        font-family: Poppins;
    
        a {
            text-decoration: none;
            color: #000;
        }
    }
    
    .box2:hover {
        transform: scale(1.1);
        transition: transform 0.3s ease;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.3), 0 6px 20px 0 rgba(0, 0, 0, 0.24);
        cursor: pointer;
    }
    
    .box3 {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        border-radius: 10px;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
        font-family: Poppins;
    
        a {
            text-decoration: none;
            color: #000;
        }
    }
    
    .box3:hover {
        transform: scale(1.1);
        transition: transform 0.3s ease;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.3), 0 6px 20px 0 rgba(0, 0, 0, 0.24);
        cursor: pointer;
    }
    
    .box4 {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        border-radius: 10px;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
        font-family: Poppins;
    
        a {
            text-decoration: none;
            color: #000;
        }
    }
    
    .box4:hover {
        transform: scale(1.1);
        transition: transform 0.3s ease;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.3), 0 6px 20px 0 rgba(0, 0, 0, 0.24);
        cursor: pointer;
    }
    
    .box5 {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        border-radius: 10px;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
        font-family: Poppins;
    
        a {
            text-decoration: none;
            color: #000;
        }
    }
    
    .box5:hover {
        transform: scale(1.1);
        transition: transform 0.3s ease;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.3), 0 6px 20px 0 rgba(0, 0, 0, 0.24);
        cursor: pointer;
    }
    
    .box6 {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        border-radius: 10px;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
        font-family: Poppins;
    
        a {
            text-decoration: none;
            color: #000;
        }
    }
    
    .box6:hover {
        transform: scale(1.1);
        transition: transform 0.3s ease;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.3), 0 6px 20px 0 rgba(0, 0, 0, 0.24);
        cursor: pointer;
    }
    
    .img {
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;
    }
    
    .box-details {
        padding: 0.4rem;
        line-height: 1.4px;
    
        .title {
            font-family: Poppins;
            font-weight: 550;
            font-size: 10px;
            text-transform: capitalize;
            color: #ff4d63;
        }
    
        .description {
            font-family: Poppins;
            font-size: 12px;
        }
    }
    
    .continue {
        display: flex;
        flex-direction: row;
        justify-content: right;
        padding-right: 0.4rem;
        font-size: 30px;
        color: rgb(237, 138, 108);
        margin-right: 10px;
        margin-top: -10px;
        margin-bottom: 10px;
    }
    
    .modal-mask {
        position: fixed;
        //z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        display: table;
        transition: opacity .4s ease;
    
        &>div {
            width: 90%;
            height: auto;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            background: #fff;
            ;
            backdrop-filter: blur(13px);
            border-radius: 10px;
            box-sizing: border-box;
            font-family: Poppins;
        }
    
        h3 {
            margin-top: 10px;
            font-size: 18px;
            color: #000;
            font-weight: bold;
            font-family: Poppins;
        }
    }
    
    .account-content {
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
    
    .account-content-h {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 50px;
    
        padding-top: 1.3rem;
        text-transform: uppercase;
        text-align: center;
        //text-decoration: underline;
    }
    
    .add-fund {
        font-size: 12px;
        text-decoration: none !important;
        text-transform: capitalize;
    }
    
    .account-content-d {
        padding-top: 1.3rem;
        font-size: 14px;
        margin-bottom: 10px;
    }
    
    .btn-secondary {
        text-transform: uppercase;
    }
    
    .modal-close {
        color: #000;
        line-height: 50px;
        font-size: 140%;
        position: absolute;
        right: 0;
        text-align: center;
        top: 2;
        width: 70px;
        text-decoration: none;
    
        &:hover {
            color: black;
        }
    }
    
    .modal-close-mobile {
        color: #000;
        line-height: 50px;
        font-size: 140%;
        position: absolute;
        right: 0;
        text-align: center;
        top: 2;
        width: 70px;
        text-decoration: none;
    
        &:hover {
            color: black;
        }
    
        display: none;
    }
    
    a {
        text-decoration: none;
    }
    
    .shop-name {
        //font-weight: 550;
        color: #000;
        font-family: Poppins;
    }
    
    @media screen and (max-width: 768px) {
        .all-users-page {
            padding: 14px;
        }

        .page-hero {
            flex-direction: column;
        }

        .hero-stats {
            min-width: 0;
            grid-template-columns: repeat(2, minmax(0, 1fr));
        }

        .page-title {
            font-size: 24px;
        }

        .page-card {
            padding: 16px;
            border-radius: 18px;
        }

        .contract-header {
            flex-direction: column;
            align-items: stretch;
            gap: 12px;
        }

        .search-wrap {
            max-width: none;
        }

        .stat-value {
            font-size: 22px;
        }

        .verification-images {
            grid-template-columns: 1fr;
        }

        .copy-refid1{
            cursor: pointer;
            font-size: 14px;
            font-weight: 600;
        }
        .inputs-field {
            font-size: 12px;
            font-family: Poppins;
            font-weight: normal;
            height: 45px;
        }
        .counter {
            font-size: 13px;
            font-weight: 500 !important;
        }
    
        .content-center {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding: 0.9rem;
        }
    
        .image-input {
            margin-top: 20px;
        }
    
        .price-fee {
            display: flex;
            flex-direction: column;
    
            div {
                width: 100%;
            }
        }
        .margin-mobile{
            margin-top: 90px;;
        }
    
        .adjust-fee-input {
            width: 100%;
        }
    
        .account-balance {
            margin-bottom: 10px;
        }
    
        .box-details {
            padding: 0.4rem;
            line-height: 1.4px;
    
            .title {
                font-family: Poppins;
                font-weight: 550;
                font-size: 8px;
                text-transform: capitalize;
                color: #ff4d63;
            }
    
            .description {
                font-family: Poppins;
                font-size: 12px;
            }
        }
    
        .inputs {
            font-size: 12px;
        }
    
        .box1 {
            width: 100%;
            height: 100%;
            border-radius: 10px;
            margin-bottom: 10px;
        }
    
        .box2 {
            width: 100%;
            height: 100%;
            border-radius: 10px;
            margin-bottom: 10px;
        }
    
        .box3 {
            width: 100%;
            height: 100%;
            border-radius: 10px;
            margin-bottom: 10px;
        }
    
        .box4 {
            width: 100%;
            height: 100%;
            border-radius: 10px;
            margin-bottom: 10px;
        }
    
        .box5 {
            width: 100%;
            height: 100%;
            border-radius: 10px;
            margin-bottom: 10px;
        }
    
        .continue {
            display: flex;
            flex-direction: row;
            justify-content: right;
            padding-right: 0.4rem;
            font-size: 30px;
            margin-top: -10px;
            color: rgb(237, 138, 108);
        }
    
        .modal-close-mobile {
            display: block;
        }
    
        .modal-close {
            display: none;
        }
    
        .account-content {
            margin: 0px;
            margin-right: 0px;
        }
    
    }
</style>
    
